import { model as router } from '!/router'
import {
  AuthFormBoxRowGaps,
  AuthFormBoxTemplate,
  ErrorMessage,
  InlineBackAngleWithTitle,
  LoginUsernameInputBlock,
  PrimarySubmitButton,
  TextBoxCaption3,
  TextBoxHeadline2,
} from '@setplex/arcana'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { type ChangeEvent, type FormEvent, type SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthLayout } from '~/widgets/auth'
import { $viewError, forgotPasswordForm, initResetPasswordFx } from './model'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='forgot_password' />
}

ForgotPasswordPage.displayName = 'ForgotPasswordPage'
export function ForgotPasswordPage(): JSX.Element {
  const { t } = useTranslation()

  const pending = useUnit(initResetPasswordFx.pending)
  const errorKey = useUnit($viewError)

  const { submit, fields, eachValid, hasError, errorText } =
    useForm(forgotPasswordForm)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit()
  }

  const onGoBack = (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    router.navigateBack()
  }

  return (
    <AuthLayout>
      <form onSubmit={onSubmit} autoComplete='off' noValidate>
        <AuthFormBoxTemplate rowGap={AuthFormBoxRowGaps.SIZE_20}>
          <a href='/sign-in' onClick={onGoBack}>
            {/* FIXME: button inside anchor is not valid HTML */}
            <InlineBackAngleWithTitle title={t('back')} />
          </a>
          <TextBoxHeadline2 title={t('reset_password')} />
          <TextBoxCaption3 title={t('email_to_reset')} />
          <LoginUsernameInputBlock
            value={fields.email.value}
            placeholder={t('email_placeholder')}
            label={t('email')}
            disabled={pending}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              fields.email.onChange(e.target.value)
            }
            errorMessage={
              hasError('email')
                ? errorText('email', {
                    required: t('email_invalid_error'),
                    email: t('email_invalid_error'),
                    invalid: t('email_invalid_error'),
                  })
                : ''
            }
            autoComplete='off'
          />
          <PrimarySubmitButton
            title={t('verify_continue')}
            disabled={pending || !eachValid}
            isLoading={pending}
          />
          {errorKey && <ErrorMessage width='100%' title={t(errorKey)} />}
        </AuthFormBoxTemplate>
      </form>
    </AuthLayout>
  )
}
